export function normalizeProviderKey(raw: string): string {
  return (raw || "").toLowerCase().replace(/\s+/g, "-").replace(/_/g, "-");
}

export function getIntegrationIconSrc(provider: string): string | null {
  const key = normalizeProviderKey(provider);
  const map: Record<string, string> = {
    slack: "/assets/integrations/slack.svg",
    github: "/assets/integrations/github.png",
    "github-white": "/assets/integrations/github-white.svg",
    gitlab: "/assets/integrations/gitlab.svg",
    jira: "/assets/integrations/jira.svg",
    linear: "/assets/integrations/linear.png",
    "linear-white": "/assets/integrations/linear-white.png",
    trello: "/assets/integrations/trello.svg",
    asana: "/assets/integrations/asana.png",
    notion: "/assets/integrations/notion.png",
    mixpanel: "/assets/integrations/mixpanel.svg",
    monday: "/assets/integrations/monday.svg",
    clickup: "/assets/integrations/clickup.svg",
    stripe: "/assets/integrations/stripe.png",
    hubspot: "/assets/integrations/hubspot.png",
    intercom: "/assets/integrations/intercom.svg",
    zendesk: "/assets/integrations/zendesk.svg",
    typeform: "/assets/integrations/typeform.svg",
    segment: "/assets/integrations/segment.png",
    mailchimp: "/assets/integrations/mailchimp.png",
    quickbooks: "/assets/integrations/quickbooks.png",
    xero: "/assets/integrations/xero.png",
    "google-analytics": "/assets/integrations/google-analytics.png",
    "google-sheets": "/assets/integrations/sheets.png",
    sheets: "/assets/integrations/sheets.png",
    drive: "/assets/integrations/drive.png",
    docs: "/assets/integrations/docs.png",
    productboard: "/assets/integrations/productboard.png",
    amplitude: "/assets/integrations/amplitude.svg",
    pendo: "/assets/integrations/pendo.png",
    airtable: "/assets/integrations/airtable.png",
    bitbucket: "/assets/integrations/bitbucket.svg",
    heap: "/assets/integrations/heap-white.svg",
  };
  return map[key] || null;
}
